import { useNavigate } from "react-router-dom";
import { XCircle } from "lucide-react";
import Navbar from "../components/Navbar";
import { Button } from "../components/ui/button";

export default function PaymentCancel() {
    const navigate = useNavigate();
    return (
        <div className="min-h-screen bg-background">
            <Navbar />
            <main className="mx-auto max-w-lg px-4 py-24 text-center" data-testid="payment-cancel-page">
                <XCircle className="mx-auto h-12 w-12 text-foreground0" />
                <h1 className="mt-6 font-heading text-2xl font-extrabold text-foreground">Checkout cancelled</h1>
                <p className="mt-2 text-sm text-muted-foreground">No worries — you haven't been charged. You can upgrade any time from your account page.</p>
                <Button onClick={() => navigate("/dashboard")} data-testid="payment-cancel-dashboard-btn" className="mt-8 bg-primary text-primary-foreground hover:bg-primary/90">
                    Back to dashboard
                </Button>
            </main>
        </div>
    );
}
